<template>
  <div>
    <v-menu v-model="menu" :nudge-width="width" close-on-content-click offset-x>
      <template v-slot:activator="{ on }">
        <div v-on="on" :class="activatorStyles">
          <slot name="activator" />
        </div>
      </template>

      <v-card>
        <v-card-text :class="contentStyles">
          <slot />
        </v-card-text>
      </v-card>
    </v-menu>
  </div>
</template>

<script>
import { css } from 'emotion'

export default {
  name: 'AppPopOver',
  props: {
    width: {
      type: Number,
      default: 200,
    },
  },
  data() {
    return {
      menu: false,
    }
  },
  computed: {
    activatorStyles() {
      return css`
        cursor: pointer;

        &:hover {
          opacity: 0.75;
        }
      `
    },
    contentStyles() {
      return css`
        cursor: pointer;
      `
    },
  },
}
</script>

<style></style>
